<template>
  <div class="p-6 bg-indigo-800 min-h-screen flex justify-center items-center">
    <div class="w-full max-w-md">
      <logo class="block mx-auto w-full max-w-xs fill-white" height="50" />
      <form class="mt-8 bg-white rounded-lg shadow-xl overflow-hidden" @submit.prevent="submit">
        <div class="px-10 py-12">
          <h1 class="text-center font-bold text-3xl">{{ __('Forgot password') }}</h1>
          <p class="mt-4 text-sm text-gray-600 text-center">
            {{ __('Enter your email address and we will send you login instructions if we find an account.') }}
          </p>
          <div v-if="$page.props.flash.success" class="mt-6 p-3 rounded bg-green-100 text-green-800 text-sm">
            {{ $page.props.flash.success }}
          </div>
          <text-input v-model="form.email" :error="form.errors.email" class="mt-8" :label="__('Email')" type="string" autofocus autocapitalize="off" />
        </div>
        <div class="px-10 py-4 bg-gray-100 border-t border-gray-100 flex justify-between items-center">
          <inertia-link class="text-sm text-indigo-600 hover:text-indigo-800" :href="route('login')">{{ __('Back to login') }}</inertia-link>
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">{{ __('Get Password') }}</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Logo from '@/Shared/Logo'
import TextInput from '@/Shared/TextInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Forgot password' },
  components: {
    LoadingButton,
    Logo,
    TextInput,
  },
  data() {
    return {
      form: this.$inertia.form({
        email: '',
      }),
    }
  },
  methods: {
    submit() {
      this.form.post(this.route('password.email'))
    },
  },
}
</script>
